angular
    .module('webcomm')
    .controller('MaxMapController', [
        '$scope',
        '$log',
        '$timeout',
        'pttService',
        'channelModel',
        'endpointModel',
        'muteService',
        function(
            $scope,
            $log,
            $timeout,
            pttService,
            channelModel,
            endpointModel,
            muteService) {
            var selectedChannel = channelModel.getSelectedChannel();
            var channelPttService = pttService.create(selectedChannel.id);

            $scope.$watch('selectedChannelId', function(newValue, oldValue) {
                channelPttService.destroy();
                channelPttService = pttService.create(newValue);
            });

            $scope.status = {
                isPTTButtonEnabled() {
                    return channelPttService.canTransmitAudio();
                },
                isPttOn() {
                    return channelPttService.isPttOn();
                },
                getPttIconName() {
                    return channelPttService.getPttIconName(false);
                }
            }

            $scope.muteStatus = {
                muteIconName() {
                    return this.isMuted() ? "off" : "on";
                },
                isMuted() {
                    return muteService.getMuteStatus(selectedChannel.id);
                },
                toggleMute() {
                    muteService.toggleMute(selectedChannel.id);
                }
            };

            $scope.pttStart = function() {
                channelPttService.pttStart();
            };

            $scope.pttStop = function() {
                channelPttService.pttStop();
            };

            $scope.closeFullscreenMap = function() {
                $scope.$emit('map.closeFullscreenMap');
            }

            var unbindEndpointsLoaded = $scope.$on('endpointModel.endpointsLoaded', function (e, channelEndpoints) {
                $scope.endpoints = channelEndpoints;
            });

            var unbindPresenceUpdated = $scope.$on('endpointModel.presenceUpdated', function (event, channelEndpoints) {
                $scope.endpoints = channelEndpoints;
            });

            $scope.$on('$destroy', function() {
                channelPttService && channelPttService.destroy();
                unbindEndpointsLoaded();
                unbindPresenceUpdated();
                $log.debug('maxMapController destroyed');
            });
        }
    ]);